exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Short media */\n.def-modal-alert[data-v-64d6159e] {\n  background: #FAFAFA;\n  border-radius: 24px;\n  padding: 24px 20px;\n  position: relative;\n}\n.def-modal-alert__close[data-v-64d6159e] {\n  display: block;\n  border: none;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background-color: transparent;\n}\n.def-modal-alert__close svg[data-v-64d6159e] {\n  display: block;\n  fill: #85898B;\n  width: 17px;\n  height: 17px;\n}", ""]);

// exports
